// extracted by mini-css-extract-plugin
export default {"container":"FundsBox_container__0Yus-","label":"FundsBox_label__G0Pz7","input":"FundsBox_input__KzGqo","red":"FundsBox_red__AgTDu"};